export default __webpack_public_path__ + "static/media/pdf.30952cc8.png";